module.exports = __webpack_public_path__ + "static/media/logo-min.b7c0e3b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-min.png
// module id = ./src/assets/images/logo-min.png
// module chunks = 0